import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
import deleteUserCard from '../../actions/setUpCardDetails.actions/deleteCardDetails';

/**
 * @class TransactionCards
 */
class TransactionCards extends React.Component {

  /**
   *
   * @param {*} cardId
   * @returns {*} - state
   */
  onDeleteCard = (cardId) => {
    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;
    const cardDetails = {
      customerId: Number(customerId),
      cardId
    };
    const { DeleteUserCard } = this.props;
    DeleteUserCard(cardDetails);
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      card,
      onChange,
      name,
      defaultChecked,
      src,
      value,
    } = this.props;
    return (
      <div className="card_options">
        <div>
          <div className="card_icon">
            <img src={src} alt="" />
          </div>
          <div className="card_name">
            <h6>
              {card.cardType}
              {' '}
              {' '}
              {card.lastFourDigit}
              {' '}
            </h6>
            <p>
                              Guaranty Trust Bank
            </p>
          </div>

        </div>
        <div>
          <label className="content">
            <input
              type="radio"
              name={name}
              value={value}
              defaultChecked={defaultChecked}
              onChange={onChange}
            />
            <span className="checkmate" />
          </label>
        </div>
        <div style={{ marginTop: '10px' }}>
          <button type="button"
            onClick={() => this.onDeleteCard(card.id)}
          >
            <i className="fas fa-trash" style={{
              color: 'red',
              cursor: 'pointer',
            }}
            />
          </button>
        </div>
      </div>
    );
  }
}

TransactionCards.propTypes = {
  card: PropTypes.shape({}),
  src: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.number,
  defaultChecked: PropTypes.bool,
  DeleteUserCard: PropTypes.func
};

export default connect(null, {
  DeleteUserCard: deleteUserCard
})(TransactionCards);
